import React from 'react';
import { Box, Typography, Paper } from '@material-ui/core';
import LayersIcon from '@material-ui/icons/Layers';

const BulkEvidenceSummary = ({ items, actionLabel }) => {
  if (!items || items.length === 0) return null;

  return (
    <Paper variant="outlined" className="custody-dialog-bulk-summary">
      <Box className="custody-dialog-bulk-summary-header">
        <LayersIcon fontSize="small" className="custody-dialog-bulk-summary-icon" />
        <Typography variant="subtitle2">
          {items.length} item{items.length !== 1 ? 's' : ''} will be {actionLabel}
        </Typography>
      </Box>

      <Box className="custody-dialog-bulk-summary-list">
        {items.map((item) => (
          <Box key={item.ptsEvidenceID} className="custody-dialog-bulk-summary-row">
            <Typography variant="body2" className="custody-dialog-bulk-summary-id">
              {item.EvidenceID}
            </Typography>
            <Typography variant="body2" className="custody-dialog-bulk-summary-desc" noWrap>
              {item.Description}
            </Typography>
            {item.Status && (
              <Typography
                variant="caption"
                className={`custody-dialog-bulk-summary-status custody-dialog-bulk-summary-status--${item.Status?.toLowerCase()}`}>
                {item.Status}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default BulkEvidenceSummary;
